import * as R from 'ramda';

/**
 * Generates a an array of dummy items to iterate over, such as for use with
 * a skeleton-screen.
 * @param {Number} length=1 How many items to populate the array with.
 * @param {String} strKey=item A key that will be used to generate an ID.
 * Useful for providing React with a key when mapping.
 * @returns {Array} An array of dummy Objects with an ID prop.
 */
const getSkeletonItems = (length = 1, strKey = 'item') => (
  R.addIndex(R.map)(
    (val, k) => ({ id: `skeleton-${strKey}-${k}` }),
    Array(length),
  )
);

export default getSkeletonItems;
